export const XL_TABLET_BREAKPOINT = 1200;

export const BREAKPOINTS = {
  TABLET: '@media (max-width: 1100px)',
  XL_TABLET: `@media (max-width: ${XL_TABLET_BREAKPOINT}px)`,
  XXL_MOBILE: '@media (max-width: 850px)',
  XL_MOBILE: '@media (max-width: 600px)',
};
